import firebase from '@config/firebase.config';
import appConfig from '@config/constants';

export const getPlanFeaturesAndModules = async () => {
  try {
    const docRef = await firebase
      .firestore()
      .collection('subscriptionsFeatures')
      .get();
    let data = {};
    docRef.docs.forEach((doc) => {
      data[doc.id] = { ...doc.data() };
    });
    return data;
  } catch (error) {
    console.error('Error getting subscription features:', error);
    throw error;
  }
};
